import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, of, tap } from 'rxjs';
import { SnackBarService } from '../services/snack-bar-service.service';
import { environment } from 'src/environments/environment';
import {
  IIncluirPerfilDto,
  IBaseResponseDto,
  IAlterarPerfilDto,
  IDesativarPerfilDto,
  IGetListaPerfilResponse,
  IGetPermissoesDto,
  IGetPermissoesResponse,
  IUsariosPerfilDto,
} from './model/interfaces-perfil';
import { IIncluirUsuarioDto } from './model/iincluir-usuario-dto';
import { UsuarioDtoResponseDto } from './model/UsuarioDtoResponse';
import {
  IAtivarDesativarUsuario,
  IUsuarioArmazenamentoLocal,
} from './model/usuario-sso-model';
import { LocalStorageService } from '../services/localstorage.service';
import { IPersmissaoSelect } from './permissao';
import { CONFIG_URLS_API } from 'src/environments/config-envs';

@Injectable({
  providedIn: 'root',
})
export class PerfisService {
  private http = inject(HttpClient);
  private localStorageService = inject(LocalStorageService);
  // private snackBar = inject(SnackBarService);

  private montarUrl(
    link: string,
    codPermissao: number,
    userGuid: string
  ): string {
    let HOST_NAME = window.location.hostname;
 
    link  = link.includes(`https://${HOST_NAME}`)? '/reportportalctf/login.aspx': link;
    link  = link.includes('.aspx')? '/reportportalctf/login.aspx': link;
    link  = link.includes('reportportalctf')? '/reportportalctf/login.aspx': link;

    !link.startsWith('http') && !link.startsWith('/') ? (link = '/' + link) : link;
    //HOST_NAME = 'homolog.portalctf.com.br';
    var novo = `https://${HOST_NAME}${link}?cmdName=${codPermissao}&userGuid=${userGuid}`;
    
  

    return novo;


  }

  public fromBinary(str: string) {
    return decodeURIComponent(
      atob(str)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
  }

  // Monta o caminho de um item de permissão.
  public formatarCaminho(p: IPersmissaoSelect, userGuid: string): string {
    var idPermissao = p.ids[p.ids.length - 1];
    var url = p.url?.toLowerCase().replace('/#', '').trim()|| '';
    var urlValida = url.length > 3 && !url.includes('apmapa');
   
    var novoLink =''
    if(urlValida)  
      novoLink = this.montarUrl(url, idPermissao, userGuid);


    var result = '';
    var ultimaString = p.caminho.length - 1;

    var caminho = p.caminho;
    result += `<strong>${p.nomePermissao}</strong>`;

    caminho.forEach((item: string, index: number) => {
      switch (index) {
        case 0:
          result += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${item}`;
          break;
        case ultimaString:
          result += urlValida
             ? ` &#8596;&#65039;<strong> <a  href="${novoLink}" target="_self" rel="${item}">${item}</a></strong>`
             : ` &#8596;&#65039; <strong>${item}</strong>`;
          break;
        default:
          result += ` &#8596;&#65039; ${item}`;
          break;
      }
    });
    // }

    return result;
  }

  public formatarCaminhoSelecionados(
    p: IPersmissaoSelect,
    userGuid: string
  ): string {

    var itensRemocao = [
      'PortalPrincipal',
      'Menu Linha1',
      'Menu Linha2',
      'Perfis'
    ];
    p.caminho = p.caminho.filter(
      (item: string) => !itensRemocao.includes(item)
    );

    var idPermissao = p.ids[p.ids.length - 1];
    var url = p.url?.toLowerCase().replace('/#', '').trim() || '';

    var novoLink =''
    var urlValida = url.length > 3 && !url.includes('apmapa');
    if(urlValida)  
      novoLink = this.montarUrl(url, idPermissao, userGuid);

    var result = '';
    var nome = p.nomePermissao || '';

    if (!itensRemocao.includes(nome)) {
      var ultimaString = p.caminho.length - 1;
      
      var caminho = p.caminho;
      result += ``;



      caminho.forEach((item: string, index: number) => {
        switch (index) {
          case 0:
            if(!urlValida){
              result +=
              caminho.length == 1 ? `<strong>${item}</strong>` : `${item}`;
            }else{
              result +=
              caminho.length == 1 && urlValida
              ? ` &#8596;&#65039;<strong> <a  href="${novoLink}" target="_self" rel="${item}">${item}</a></strong>` 
              : `${item}`;
            }
            break;
          case ultimaString:
            result += urlValida
              ? ` &#8596;&#65039;<strong> <a  href="${novoLink}" target="_self" rel="${item}">${item}</a></strong>`
              : ` &#8596;&#65039; <strong>${item}</strong>`;
            break;
          default:
            result += ` &#8596;&#65039; ${item}`;
            break;
        }
      });
    }

    return result;
  }

  public getListUsuariosPorEntidade(
    userGuid: string
  ): Observable<UsuarioDtoResponseDto> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userguid: userGuid,
      }),
    };

    return this.http
      .get<UsuarioDtoResponseDto>(
        environment.host_ctf_service + CONFIG_URLS_API.API_GetListaUsuariosAsync,
        { headers: httpOptions.headers }
      )
      .pipe(
        tap(() => {}),
        catchError(
          this.handleError<UsuarioDtoResponseDto>(
            'Ocorreu um erro; não foi possível obter a lista de usuários!',
            {
              sucesso: false,
              mensagens: [
                'Ocorreu um erro; não foi possível obter a lista de usuários!',
              ],
            }
          )
        )
      );
  }

  public getUsuarioLocalStorage(): Observable<IUsuarioArmazenamentoLocal> {
    let userData = this.localStorageService.getItem('userData');
    let user = JSON.parse(userData);
    if (user != null && user.retorno != null) {
      return of<IUsuarioArmazenamentoLocal>(user.retorno);
    } else {
      this.handleError<IUsuarioArmazenamentoLocal>(
        'Ocorreu um erro; não foi possível dados do usuário!'
      );
      return of(null as unknown as IUsuarioArmazenamentoLocal);
    }
  }

  public criarPerfil(
    dto: IIncluirPerfilDto,
    userGuid: string
  ): Observable<IBaseResponseDto> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userguid: userGuid,
      }),
    };
    return this.http
      .post<IBaseResponseDto>(
        environment.host_ctf_service + CONFIG_URLS_API.API_CriarPerfilAsync,
        dto,
        { headers: httpOptions.headers }
      )
      .pipe(
        tap((response) => {}),
        catchError(
          this.handleError<IBaseResponseDto>(
            'Não foi possível criar o Perfil.',
            { sucesso: false, mensagens: ['Não foi possível criar o Perfil.'] }
          )
        )
      );
  }

  public getUsuariosPorPerfil(
    idPerfil: number,
    userGuid: string
  ): Observable<IUsariosPerfilDto> {
    let url = `${environment.host_ctf_service}${CONFIG_URLS_API.API_GetListUsuariosPorPerfilAsync}/${idPerfil}`;
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userguid: userGuid,
      }),
    };

    return this.http
      .get<IUsariosPerfilDto>(url, { headers: httpOptions.headers })
      .pipe(
        tap((response) => {}),
        catchError(
          this.handleError<IUsariosPerfilDto>(
            'Não foi possível buscar os usuários para o Perfil.',
            {
              sucesso: false,
              mensagens: ['Não foi possível buscar os usuários para o Perfil'],
            }
          )
        )
      );
  }

  public alterarPerfil(
    dto: IAlterarPerfilDto,
    userGuid: string
  ): Observable<IBaseResponseDto> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userguid: userGuid,
      }),
    };

    return this.http
      .put<IBaseResponseDto>(
        environment.host_ctf_service + CONFIG_URLS_API.API_AlterarPerfilAsync,
        dto,
        { headers: httpOptions.headers }
      )
      .pipe(
        tap((response) => {}),
        catchError(
          this.handleError<IBaseResponseDto>(
            'Não foi possível alterar o Perfil.',
            {
              sucesso: false,
              mensagens: ['Não foi possível alterar o Perfil.'],
            }
          )
        )
      );
  }

  public desativarPerfil(
    dto: IDesativarPerfilDto,
    userGuid: string
  ): Observable<IBaseResponseDto> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userguid: userGuid,
      }),
    };
    return this.http
      .put<IBaseResponseDto>(
        environment.host_ctf_service + CONFIG_URLS_API.API_DesativarPerfilAsync,
        dto,
        { headers: httpOptions.headers }
      )
      .pipe(
        tap((response) => {}),
        catchError(
          this.handleError<IBaseResponseDto>(
            'Não foi possível desativar o Perfil.',
            {
              sucesso: false,
              mensagens: ['Não foi possível desativar o Perfil.'],
            }
          )
        )
      );
  }

  public getListaPerfisCriados(
    userGuid: string
  ): Observable<IGetListaPerfilResponse> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userguid: userGuid,
      }),
    };

    return this.http
      .get<IGetListaPerfilResponse>(
        environment.host_ctf_service + CONFIG_URLS_API.API_PegarListaPerfisAsync,
        { headers: httpOptions.headers }
      )
      .pipe(
        tap((response) => {}),
        catchError(
          this.handleError<IGetListaPerfilResponse>(
            'Não foi possível buscar a lista de perfis.',
            {
              sucesso: false,
              mensagens: ['Não foi possível buscar a lista de perfis.'],
            }
          )
        )
      );
  }

  public getListaPermissoes(
    dto: IGetPermissoesDto,
    userGuid: string
  ): Observable<IGetPermissoesResponse> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userguid: userGuid,
      }),
    };

    return this.http
      .post<IGetPermissoesResponse>(
        environment.host_ctf_service + CONFIG_URLS_API.API_GetListPermissaoAsync,
        dto,
        { headers: httpOptions.headers }
      )
      .pipe(
        tap((response) => {}),
        catchError(
          this.handleError<IGetPermissoesResponse>(
            'Não foi possível buscar a lista de perfis.',
            {
              sucesso: false,
              mensagens: ['Não foi possível buscar a lista de permissoes.'],
            }
          )
        )
      );
  }

  private getProjeto(): string {
    let host = window.parent.location.host + '/';
    let urlCompleta = window.parent.location.href;

    let primeiraParte = urlCompleta.split(host)[1];
    let resultado = primeiraParte.split('/')[0];
    return resultado.toLowerCase();
  }

  public getPerfis(usuario: IUsuarioArmazenamentoLocal): Observable<any> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Response-Type': 'blob',
        projeto: this.getProjeto(),
        //projeto: 'portalctf',
        userguid: usuario.guid,
      }),
    };

    return this.http
      .get(
        environment.host_ctf_service + CONFIG_URLS_API.API_GetPermissoesTemplate,
        httpOptions
      )
      .pipe(
        tap((response) => {}),
        catchError(
          this.handleError<any>('Não foi possível consultar os Perfis.', [])
        )
      );
  }

  public addAusuarioNoPerfil(
    dto: IIncluirUsuarioDto,
    userGuid: string
  ): Observable<IBaseResponseDto> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userguid: userGuid,
      }),
    };
    return this.http
      .post<IBaseResponseDto>(
        environment.host_ctf_service + CONFIG_URLS_API.API_CriarUsuarioAsync,
        dto,
        { headers: httpOptions.headers }
      )
      .pipe(
        tap((response) => {}),
        catchError(
          this.handleError<IBaseResponseDto>(
            'Não foi possível criar o Perfil.',
            { sucesso: false, mensagens: ['Não foi possível criar o Perfil.'] }
          )
        )
      );
  }

  public ativarDesativarUsuario(
    ativarDesativarUsuarioDto: IAtivarDesativarUsuario,
    userGuid: string
  ): Observable<IBaseResponseDto> {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        userguid: userGuid,
      }),
    };

    return this.http
      .post<IBaseResponseDto>(
        environment.host_ctf_service +
        CONFIG_URLS_API.API_AtivarDesativarUsuarioAsync,
        ativarDesativarUsuarioDto,
        { headers: httpOptions.headers }
      )
      .pipe(
        tap((response) => {}),
        catchError(
          this.handleError<IBaseResponseDto>(
            'Ocorreu um erro; não foi possível ativar | desativar o usuário!',
            {
              sucesso: false,
              mensagens: [
                'Ocorreu um erro; não foi possível ativar | desativar o usuário!',
              ],
            }
          )
        )
      );
  }

  private handleError<T>(
    mensagem = 'Não foi possível realizar a operação.',
    result?: T
  ) {
    return (error: any): Observable<T> => {
      return of(result as T);
    };
  }
}
